<div class="container">

  <!-- PATIENT DATA -->
  <div class="row" *ngIf="patient">
      <mc-patient-header [patient]="patient" [showPhones]="true"></mc-patient-header>
      <div *ngIf="lastAppointmentDate" class="mt-5 ml-auto">
          <strong>Última consulta:</strong> {{ lastAppointmentDate | date: 'dd/MM/yyyy' }}
      </div>
  </div>

  <!-- DOCTOR, PAYMENT AND TYPE DATA -->
  <div class="row">
    <div class="form-group col col-6 pl-0 pr-0">
      <label for="doctor">Médico</label>
      <select id="doctor" class="form-control" name="doctor" [(ngModel)]="selectedDoctor" (change)="onSelectedDoctorChanged()" required>
        <option *ngFor="let d of doctors" [ngValue]="d">{{d.name}}</option>
      </select>
    </div>
    <div class="form-group col col-3 pr-0" *ngIf="patient">
      <label for="payment">Pagamento</label>
      <select id="payment" class="form-control" name="payment" [(ngModel)]="selectedType" required>
        <option *ngFor="let st of schedulingTypes" [ngValue]="st">{{st.name}}</option>
      </select>
    </div>

    <div class="form-group col col-3 pr-0" *ngIf="patient">
      <label for="appointmentType">Tipo</label>
      <select id="appointmentType" class="form-control" name="appointmentType" [(ngModel)]="selectedAppointmentType" required>
        <option *ngFor="let at of appointmentTypes" [ngValue]="at">{{at.name}}</option>
      </select>
    </div>

  </div>

  <!-- DATE SELECTOR -->
  <div *ngIf="selectedDoctor" class="row mb-3">
    <div class="form-group col pl-0">
      <my-date-picker
          (dateChanged)="onSelectedDateChanged($event)"
          id="selectedDate"
          name="selectedDate"
          [options]="myDpOptions"
          [ngModel]="selectedDate"
          required>
      </my-date-picker>
    </div>

    <!-- SCHEDULING LIST -->
    <div *ngIf="selectedDate" class="col-9 card">
      <div class="list-group list-group-flush pl-0 pr-0 pb-0 ml-0 mr-0">

        <div *ngIf="loadingSchedulings" class="text-center">
          <div class="spinner-border mt-5" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <div *ngIf="!loadingSchedulings">
          <div class="list-group-item pl-0 pr-0 pb-0 ml-0 mr-0 d-flex" *ngFor="let sched of selectedDateSchedules">
            <div class="pl-0 pr-0"><strong>{{sched.whenisit | date:'HH:mm'}}</strong></div>
            <mc-patient-header class="ml-3"
                [patient]="sched.patient"
                [showPhones]="patient === undefined"
                [schedulingTypeName]="sched.type.name"
                [appointmentTypeName]="sched.appointment_type.name"></mc-patient-header>

            <div class="ml-auto p-2">
                <div *ngIf="(authService.isRecepcionist() || authService.isAdmin()) && !patient">
                    <button class="btn btn-link p-0 m-1" (click)="toggleSchedulingConfirmation(sched.id)">
                      <fa-icon *ngIf="!sched.confirmation" class="fa-lg" [icon]="farCalendarCheck" data-toggle="tooltip" title="Marcar Confirmado"></fa-icon>
                      <fa-icon *ngIf="sched.confirmation" class="fa-lg" [icon]="calendarCheck" data-toggle="tooltip" title="Desmarcar Confirmado"></fa-icon>
                    </button>

                    <button class="btn btn-link p-0 m-1" (click)="toggleSchedulingArrival(sched.id)">
                      <fa-icon *ngIf="!sched.arrival" class="fa-lg" [icon]="farUser" data-toggle="tooltip" title="Marcar Chegada"></fa-icon>
                      <fa-icon *ngIf="sched.arrival" class="fa-lg" [icon]="userCheck" data-toggle="tooltip" title="Desmarcar Chegada"></fa-icon>
                    </button>

                    <button class="btn btn-link p-0 m-1" (click)="confirmSchedulingDelete(sched.id)">
                      <fa-icon class="fa-lg" [icon]="trashAlt" data-toggle="tooltip" title="Excluir"></fa-icon>
                    </button>

                    <button class="btn btn-link p-0 m-1" type="button" routerLink="/paciente/{{sched.patient.id}}">
                        <fa-icon class="fa-lg" [icon]="addressCard" data-toggle="tooltip" title="Cadastro paciente"></fa-icon>
                    </button>
                </div>


                <div *ngIf="(authService.isDoctor() || authService.isAdmin()) && !patient" class="text-primary fa-lg">
                    <fa-icon *ngIf="sched.confirmation" class="p-0 m-1" [icon]="calendarCheck" data-toggle="tooltip" title="Paciente confirmado"></fa-icon>
                    <fa-icon *ngIf="sched.arrival" class="p-0 m-1" [icon]="userCheck" data-toggle="tooltip" title="Paciente chegou"></fa-icon>

                    <button class="btn btn-link p-0 ml-2 m-1" type="button" routerLink="/paciente/{{sched.patient.id}}/atendimento">
                        <fa-icon class="fa-lg" [icon]="userMd" data-toggle="tooltip" title="Prontuário paciente"></fa-icon>
                    </button>
                </div>

            </div>
          </div>

          <div class="text-center">
            <div *ngIf="selectedDateSchedules?.length == 0" class="list-group-item">
              <span class="h5"><em>Não existem marcações para a data selecionada</em></span>
            </div>
          </div>

          <div class="list-group-item" *ngIf="patient && selectedDoctor && selectedDate">
          <div class="row">
            <div class="col"></div>
            <div class="form-group col col-sm mr-1">
              <label for="times">Horários disponíveis: </label>
              <select id="times" class="form-control" name="times" [(ngModel)]="selectedTime" (change)="onSelectedTimeChanged()" required>
                <option *ngFor="let t of availableTimes" [ngValue]="t">{{t}}</option>
              </select>
            </div>
            <button class="btn btn-primary float-right mb-2" [disabled]="!selectedTime" (click)="saveScheduling()">Agendar</button>
          </div>
          </div>
        </div>

      </div>
    </div>

  </div>

</div>


<!-- Modal -->
<div class="modal fade" #confirmDeleteSchedulingModal tabindex="-1" role="dialog" aria-labelledby="confirmDeleteSchedulingModal" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalLabel">Exclusão</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="schedulingToDelete">
        <span>Confirma a exclusão da marcação para paciente <strong>{{schedulingToDelete.patient.name}}</strong>?</span>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="deleteScheduling()">Excluir</button>
      </div>
    </div>
  </div>
</div>
